import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Dropdown from 'components/CncUI/Dropdown';
import TextField from 'components/CncUI/TextField';
import { TextFieldPhone } from 'components/CncUI/TextField';
import Button from 'components/CncUI/Button';
import SearchFieldAddress from 'components/SearchFieldAddress';

import fmsEnums from 'constants/componentData/fmsEnums';

const PRIMARY = fmsEnums.typeofContact.primary;
const SECONDARY = fmsEnums.typeofContact.secondary;

const useStyles = makeStyles(() => ({
  actions: {
    marginTop: 24,
    marginBottom: -16,
  },
}));

const EditForm = props => {
  const classes = useStyles();
  const { name, address, phone, mobile, contact, dbCode } = props;
  const { mappings, onCancel, onSave } = props;
  const [loading, setLoading] = useState(false);

  const trimPhone = number =>
    number && number.replace('+1', '').replace(/\D/g, '');

  const slicedAddress = { ...address };
  delete slicedAddress.__typename;

  const [form, setForm] = useState({
    name: name,
    address: slicedAddress,
    phone: trimPhone(phone && phone.cell),
    mobile: trimPhone(mobile && mobile.cell),
    relationship: contact.relationship || 1,
  });

  const handleChange = event => {
    const {
      target: { name, value },
    } = event;
    setForm({ ...form, [name]: value });
  };

  const onAddressSelect = selected => {
    setForm({
      ...form,
      address: {
        city: selected.City,
        state: selected.ProvinceCode,
        addressLine1: selected.Line1,
        addressLine2: selected.Line2,
        addressLine3: selected.Line3,
        typeofContact: PRIMARY,
        zipCode: selected.PostalCode,
        country: selected.CountryIso2,
      },
    });
  };

  const longAddress = addressFormData => {
    const { city, state, zipCode } = addressFormData;
    const { addressLine1, addressLine2 } = addressFormData;
    const address = [addressLine1, addressLine2].filter(Boolean).join(' ');
    const stateZipCode = [state, zipCode].filter(Boolean).join(' ');
    return [address, city, stateZipCode].filter(Boolean).join(', ');
  };

  const valid = () => {
    const { phone, mobile } = form;
    const validPhone = !phone || phone.replace(/\D/g, '').length === 10;
    const validMobile = !mobile || mobile.replace(/\D/g, '').length === 10;
    if (!validPhone || !validMobile) return false;
    return !!form.name;
  };

  const save = () => {
    setLoading(true);
    onSave({
      basicInfo: { dbCode },
      alternativeContacts: [
        {
          relationship: parseInt(form.relationship, 10),
          basicInfo: {
            name: form.name,
          },
          addresses:
            form.address && form.address.addressLine1 ? [form.address] : [],
          phoneNumbers: [
            {
              typeofContact: PRIMARY,
              cell: trimPhone(form.phone),
            },
            {
              typeofContact: SECONDARY,
              cell: trimPhone(form.mobile) || '',
            },
          ],
        },
      ],
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item md={12} xs={12}>
            <TextField
              required
              fullWidth
              name="name"
              label="Full Name"
              value={form.name}
              onChange={handleChange}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <SearchFieldAddress
              label="Search Address"
              onSelect={data => onAddressSelect(data)}
              onEmpty={() => onAddressSelect({})}
              value={longAddress(form.address)}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextFieldPhone
              fullWidth
              label="Phone Number"
              name="phone"
              onChange={handleChange}
              value={form.phone}
              inputProps={{
                pattern: '[0-9]*',
                inputMode: 'numeric',
              }}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextFieldPhone
              fullWidth
              label="Mobile Number"
              name="mobile"
              onChange={handleChange}
              value={form.mobile}
              inputProps={{
                pattern: '[0-9]*',
                inputMode: 'numeric',
              }}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Dropdown
              fullWidth
              name="relationship"
              label="Relationship"
              value={form.relationship}
              onChange={handleChange}
              data={mappings.relationship}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.actions}>
        <Grid container spacing={2} justify="flex-end">
          <Grid item>
            <Button
              secondary
              disabled={loading}
              onClick={onCancel}
              id="EmergencyContact-CancelButton"
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              loading={loading}
              disabled={!valid()}
              onClick={save}
              id="EmergencyContact-SaveButton"
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EditForm;
